var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('fragment', _vm._l(_vm.optionsData, function (op, opIndex) {
    var _op$children, _op$children2;
    return _c('fragment', {
      key: opIndex
    }, [_c('li', {
      staticClass: "p-[1px] cursor-pointer",
      class: []
    }, [op !== null && op !== void 0 && (_op$children = op.children) !== null && _op$children !== void 0 && _op$children.length ? _c('i', {
      class: ['mr-3 w-1', _vm.chevronClasses(op.expand)],
      on: {
        "click": function ($event) {
          op.expand = !op.expand;
        }
      }
    }) : _vm._e(), _c('input', {
      ref: "checkBoxRef",
      refInFor: true,
      attrs: {
        "type": _vm.multiple ? 'checkbox' : 'radio'
      },
      domProps: {
        "checked": _vm.checkItemIsSelected(op.id)
      },
      on: {
        "change": function ($event) {
          return _vm.handleClickOptionItem(op);
        }
      }
    }), _c('span', {
      staticClass: "ml-2",
      on: {
        "click": function ($event) {
          return _vm.handleClickOptionItem(op);
        }
      }
    }, [_vm._v(_vm._s(op.text))])]), op !== null && op !== void 0 && (_op$children2 = op.children) !== null && _op$children2 !== void 0 && _op$children2.length && op !== null && op !== void 0 && op.expand ? _c('ul', {
      staticClass: "ml-5"
    }, [_c('OptionItems', {
      attrs: {
        "checkItemIsSelected": _vm.checkItemIsSelected,
        "handleClickOptionItem": _vm.handleClickOptionItem,
        "multiple": _vm.multiple,
        "optionsData": op.children
      }
    })], 1) : _vm._e()]);
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }